// Minutos -> "3 h 30 min" / "2 h" / "30 min"
export const formatMinutes = (total) => {
  const mins = Math.max(Number(total) || 0, 0);
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h && m) return `${h} h ${m} min`;
  if (h) return `${h} h`;
  return `${m} min`;
};
